import React, { 
  //useState, 
  //useEffect, 
  useRef, 
  useCallback 
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectPodcastSubmit, setRecaptcha, setFileValidate, resetFileValidate, postPodcastSearch } from '../podcastSubmitSlice'
//import { selectDashboard, } from '../../dashboard/dashboardSlice'

//import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
//import validator from 'validator';

import {useDropzone} from 'react-dropzone'
import * as jsonify from 'jsonify-that-feed';

import {fromXML} from "from-xml";
import {toXML} from "to-xml";

import * as xmlSanitizer from 'xml-sanitizer'

import {
  Button,
  Card,
  Form,
  Message,
  Icon,
  Divider,
  //Image,
  Item,
  Popup,
} from 'semantic-ui-react';

//images
//import icon_openFolder from './images/open-folder-icon.png';
//import icon_opmlFileType from './images/opml-file-type-icon.png';

export default function PodcastRssValidate(props) {

  //const fromView = props.fromView;
  //console.debug('PodcastRssValidate - fromView', fromView);

  const recaptchaRef = useRef();

  const dispatch = useDispatch()
  const { recaptcha, fileUpload, podcastSearch, } = useSelector(selectPodcastSubmit);
  const { loading, formError, error, } = fileUpload;

  /* useEffect(() => {
    if (!loading && !error && (recaptcha && recaptcha.valid && recaptcha.value ) && (rssFeedUrl && rssUrlValid)) {
      dispatch(postRssValidate({recaptchaToken: recaptcha.value, rssFeedUrl}));
    }
  }, [dispatch, loading, error, rssUrlValid, rssFeedUrl, recaptcha]) */

  //const handleChange = (e, { name, value }) => setFormState({ [name]: value ? value : ''});
  //console.debug('formState', formState.rssFeedUrl);

  // Form - Google reCaptcha
  const recaptcha_scriptLoaded = () => {
    //console.debug('recaptcha_scriptLoaded');
  }
  /* const recaptcha_ref_reset = () => {
    console.debug('recaptcha_ref_reset');
    console.debug('recaptcha_ref_reset', recaptchaRef);
    const recaptchaRef = recaptchaRef.current;
    console.debug('recaptcha_ref_reset', recaptchaRef);
    recaptchaRef.reset();
  } */
  const recaptcha_onChange = (value) => {
    //console.debug('Captcha value:', value);
    dispatch(setRecaptcha({value: value}));
  }
  const recaptcha_onError = () => {
    //console.debug('recaptcha_onError');
    const error = {
      type: 'recaptcha',
      message: 'Network error: please try again.'
    };
    dispatch(setRecaptcha({error: error,}));
    //this.recaptcha_ref_reset();
  }
  const recaptcha_onExpired = () => {
    //console.debug('recaptcha_onExpired');
    const error = {
      type: 'recaptcha',
      message: 'Expired: please try again.'
    };
    dispatch(setRecaptcha({error: error,}));
    //recaptcha_ref_reset();
  }

  const submitButtonDisabled = !recaptcha.valid ? true : fileUpload.loading ? true : (fileUpload.json === null || typeof fileUpload.json?.body?.outline === 'undefined' || fileUpload.json.body.outline.length === 0) ? true : (fileUpload.formError || !fileUpload.valid) ? true : podcastSearch.loading ? true : false;

  const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    //console.debug('onDrop - acceptedFiles', acceptedFiles);
    //console.debug('onDrop - rejectedFiles', rejectedFiles);

    const readFile = (file) => new Promise((resolve, reject) => {
      //console.debug('readFile - file', file);
      const reader = new FileReader();
      reader.readAsText(file);
      //reader.readAsDataURL(file);
      //reader.readAsBinaryString(file);
      reader.onabort = () => {
        //console.debug('readFile - file reading was aborted');
        reject('file reading was aborted');
      }
      reader.onerror = () => {
        //console.debug('readFile - file reading has failed');
        //dispatch(setFileValidate({ error: 'file reading has failed', }));
        reject('file reading has failed');
      }
  
      const parseXmlString = async (readerResult) => {
        return new Promise((resolve, reject) => {
          //console.debug('parseXmlString - readerResult', readerResult);
          // theres a bunch of bad data we need to remove to parse xml correctly
          const sanitizeXmlString = xmlSanitizer(readerResult).replaceAll('&quot;', '');
          //console.debug('parseXmlString - sanitizeXmlString', sanitizeXmlString);
          const xml = fromXML(sanitizeXmlString);
          //console.debug('parseXmlString - xml', xml);

          const opmlFileTypesValidation = {
            stitcher: {
              valid: xml && xml.opml && xml.opml.body && xml.opml.body.outline && Array.isArray(xml.opml.body.outline) && xml.opml.body.outline.length !== 0
            },
            googlePodcasts: {
              valid: xml && xml.opml && xml.opml.body && xml.opml.body.outline && xml.opml.body.outline.outline && Array.isArray(xml.opml.body.outline.outline) && xml.opml.body.outline.outline.length !== 0
            }
          }
          //console.debug('parseXmlString - opmlFileTypesValidation', opmlFileTypesValidation);

          if (opmlFileTypesValidation.stitcher.valid === true) {
            //console.debug('opmlFileTypesValidation.stitcher.valid');
            for (let xmlItem of xml.opml.body.outline) {
              if (typeof xmlItem['@description'] !== 'undefined' && xmlItem['@description'] !== '') {
                xmlItem['@description'] = ''
              }
            }
            //console.debug('parseXmlString - xml - @description removed', xml);
            const string = toXML(xml, null, 2);
            //console.debug('parseXmlString - string', string);
            resolve(string)
          } else if (opmlFileTypesValidation.googlePodcasts.valid === true) {
            //console.debug('opmlFileTypesValidation.googlePodcasts.valid');
            const string = toXML(xml, null, 2);
            //console.debug('parseXmlString - string', string);
            resolve(string)
          } else {
            reject('No Podcasts to import')
          }
        })
      }
  
      reader.onload = async () => {
        if (!!reader.result) {
          //console.debug('readFile - reader.result', reader.result);
          try {
            let parsedXmlString = await parseXmlString(reader.result);
            //console.debug('readFile - parsedXmlString', parsedXmlString);
            const res = jsonify.opmlToJson(parsedXmlString);
            //console.debug('readFile - res', res);
            resolve({ 
              fileName: file.name,
              fileData: reader.result.toString(), 
              json: res, 
            });
          } catch (error) {
            //console.debug('readFile - error', error);
            reject(error.toString());
          }
        } else {
          //console.debug('readFile - no reader.result');
          reject('no reader.result');
        }
      }
    });

    if (acceptedFiles.length !== 0) {
      // run async validation tests here
      const file = acceptedFiles[0];
      try {
        const res = await readFile(file);
        //console.debug('onDrop - res', res);
        // validate expected object schema
        const opmlSchemaTypesValidation = {
          stitcher: {
            valid: res && res.json && res.json.body && (res.json.body.outline && Array.isArray(res.json.body.outline) && res.json.body.outline.length !== 0) && (!res.json.body.outline[0].outline)
          },
          googlePodcasts: {
            valid: res && res.json && res.json.body && (res.json.body.outline && Array.isArray(res.json.body.outline) && res.json.body.outline.length === 1) && (res.json.body.outline[0].outline && Array.isArray(res.json.body.outline[0].outline) && res.json.body.outline[0].outline.length !== 0)
          }
        }
        //console.debug('onDrop - opmlSchemaTypesValidation', opmlSchemaTypesValidation);

        //const isExpectedSchema = res && res.json && res.json.body && (res.json.body.outline && res.json.body.outline.length !== 0);
        //console.debug('onDrop - isExpectedSchema', isExpectedSchema);

        if (opmlSchemaTypesValidation.stitcher.valid) {
          //console.debug('onDrop - opmlSchemaTypesValidation.stitcher.valid');
          //check the json objects schema for title + xmlUrl
          for (let podcast of res.json.body.outline) {
            const isExpectedSchemaItem = podcast && (podcast.title && podcast.title.length !== 0) && (podcast.xmlUrl && podcast.xmlUrl.length !== 0);
            if (isExpectedSchemaItem) {
              podcast.valid = true
            } else {
              podcast.valid = false
            }
          }
          dispatch(setFileValidate(res));
          return true
        } else if (opmlSchemaTypesValidation.googlePodcasts.valid) {
          //console.debug('onDrop - opmlSchemaTypesValidation.googlePodcasts.valid');
          //check the json objects schema for title + xmlUrl
          let formattedArray = [];
          let formattedResponse = JSON.parse(JSON.stringify(res))
          for (let podcast of res.json.body.outline[0].outline) {
            //console.debug('onDrop - podcast', podcast);
            //update podcast text property to title to match stitcher
            podcast.title = podcast.text ? podcast.text : null; 
            const isExpectedSchemaItem = podcast && (podcast.title && podcast.title.length !== 0) && (podcast.xmlUrl && podcast.xmlUrl.length !== 0);
            if (isExpectedSchemaItem) {
              podcast.valid = true
            } else {
              podcast.valid = false
            }
            formattedArray = [...formattedArray, podcast]
          }
          formattedResponse.json.body.outline = formattedArray
          //console.debug('onDrop - formattedResponse', formattedResponse);
          dispatch(setFileValidate(formattedResponse));
          return true
        } else {
          const errorBody = 'Parsing Failed'
          throw errorBody
        }
      } catch (error) {
        //console.debug('onDrop - isOpmlFileValid - error', error);
        dispatch(setFileValidate({error: 'File Invalid'}));
        return false
      }
    }
    if (rejectedFiles.length !== 0) {
      const fileRejected = rejectedFiles[0];
      dispatch(setFileValidate({error: fileRejected.errors[0].message}));
      return false
    }
  }, [dispatch]);

  const {
    //acceptedFiles,
    //fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    open,
  } = useDropzone({
    onDrop, // onDrop callback function
    maxFiles: 1, // max files allowed
    accept: { // file type checker
      'application/xml': ['.opml'],
      'text/xml': ['.opml'],
      'text/x-opml': ['.opml'],
      'text/x-opml+xml': ['.opml'],
      //'text/*': ['.opml'],
    },
    noClick: true, // disable click inside
    noKeyboard: true, // disable keyboard inside
    //validator: fileValidationTests, // simple non async validation tests
  });

  /* function fileValidationTests(file) {
    console.debug('fileValidationTests - file', file);
    dispatch(toggleFileValidateLoading());
    let conditions = {
      file: {
        name: {
          maxLength: 200
        }
      }
    }
    let tests = {
      fileNameLength: {
        test: file.name.length > conditions.file.name.maxLength,
        message: {
          code: "name-too-large",
          message: `File Name is larger than ${conditions.file.name.maxLength} characters`
        }
      },
    }
    if (tests.fileNameLength.test) {
      return tests.fileNameLength.message
    }
    return null
  } */

  /* const acceptedFileItems = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  )); */

  return (
    <>
      <div className={'view-activate'}>
        <Card.Header>Upload Your Podcast Subscriptions</Card.Header>
        <Card.Description>
          <p>Add the file exported from your current Podcast Subscription service to automatically find matching Podcasts on iHeartRadio.</p>
          <Form error={fileUpload.formError} success={fileUpload.valid}>
            <Form.Field required className={'file-uploader'}>
              {fileUpload && !fileUpload.loading && !fileUpload.error && fileUpload.valid ?
                <>
                  {/* <Icon size={'huge'} color={'green'} name='check circle outline' /> */}
                  <h3>File added successfully!</h3>
                  <Item.Group unstackable>
                    <Item>
                      {/* <Item.Image size='mini' src={icon_opmlFileType} alt={'file type icon'} /> */}
                      <Icon className={'image'} size={'large'} color={'green'} name='check circle outline' />
                      <Item.Content verticalAlign={'middle'}>
                        <Item.Header>{fileUpload.fileName}</Item.Header>
                      </Item.Content>
                      <Popup basic inverted hoverable position='bottom center' trigger={
                        <Button basic icon size={'mini'} aria-label={'Remove File'}
                        onClick={()=>{dispatch(resetFileValidate())}}
                        >
                          <Icon name='remove' />
                        </Button>
                      }>
                          <p style={{fontSize: '12px'}}>Remove File</p>
                        </Popup>
                    </Item>
                  </Item.Group>
                </>
              :
                <>
                  <div {...getRootProps({className: 'dropzone'+ (isDragActive ? ' dragging' : '')})}>
                  <input {...getInputProps()} />
                  {isDragActive ?
                    <h4>Drop Your File Here</h4>
                  :
                    <React.Fragment>
                      <Icon.Group size='huge'>
                        <Icon size='mini' name='arrow up' />
                        <Icon name='file outline' />
                      </Icon.Group>
                      {/* <Icon size={'huge'} name={'upload'} style={{opacity: '0.5'}} alt={'open folder icon'} /> */}
                      {/* <Image size={'tiny'} src={icon_openFolder} alt={'open folder icon'} /> */}
                      <h4>Drag & Drop Your File Here</h4>
                      <Divider horizontal>Or</Divider>
                      <Button aria-label={'Browse Files'} className={'select-file'} secondary size={'small'} icon labelPosition={'left'} onClick={open}>
                        <Icon name='file alternate outline' />
                        Browse Files
                      </Button>
                    </React.Fragment>
                  }
                </div>
                <div className={'file-requirements'}>
                  <p><small>Only .opml or .xml files accepted</small></p>
                </div>
                {fileUpload && !fileUpload.loading && fileUpload.error ?
                  <Message error size={'tiny'} content={fileUpload.error} />
                :
                  null
                }
                {/* <aside>
                  <h4>Accepted files</h4>
                  <ul>{acceptedFileItems}</ul>
                  <h4>Rejected files</h4>
                  <ul>{fileRejectionItems}</ul>
                </aside> */}
                </>
              }
            </Form.Field>
            {/* <Form.Field required>
              <Form.Input type="text" min="5"
                placeholder='Enter RSS Feed URL...'
                name='rssFeedUrl'
                value={formState.rssFeedUrl}
                onChange={handleChange}
                error={formError}
                //disabled={rssUrlValid}
                readOnly={rssUrlValid}
              />
              {!loading && formError && error && error.type === 'validate-url' ?
                <Message error size={'tiny'} header={error.message} />
              :
                null
              }
              {!loading && formError && error && error.type === 'validate-rss' ?
                <Message error size={'tiny'} header={error.message} content={error.rawError} />
              :
                null
              }
            </Form.Field> */}
            <Form.Field required className={'recaptcha-field'}>
              <ReCAPTCHA ref={recaptchaRef} tabindex={2} isolated={'true'} size={'normal'} theme={'light'}
                sitekey={recaptcha.sitekey}
                asyncScriptOnLoad={recaptcha_scriptLoaded}
                onChange={recaptcha_onChange}
                onErrored={recaptcha_onError}
                onExpired={recaptcha_onExpired}
              />
              {!loading && formError && error && error.type === 'recaptcha' ?
                <Message error size={'tiny'} header={error.message} />
              :
                null
              }
            </Form.Field>
          </Form>

          <Button primary fluid aria-label={'Submit Import Podcast Subscriptions'}
            loading={loading || podcastSearch.loading}
            disabled={submitButtonDisabled}
            onClick={()=>{dispatch(postPodcastSearch({recaptchaToken: recaptcha.value, lookup: fileUpload.json.body.outline}))}}
          >
            Import Podcast Subscriptions
          </Button>

          {/* <div className={'extra'}>
            <p>If your podcast is already on iHeartRadio and you need to make a change to your iHeartRadio podcast page, please access Your Dashboard.</p>
            <Button as={Link} secondary fluid
              to={'/dashboard'}
            >
              Your Dashboard
            </Button>
          </div> */}
        </Card.Description>
      </div>
    </>
  )
}